import { API_URLS, } from "@constants";
import * as G from "@globals";
import * as Q from "../queries";



export const gql = async <T extends object>(queryName: keyof typeof Q, ...args: (string | number | undefined)[] ):Promise<T | null> => {

	const { GRAPHQL_API } = API_URLS;
	const { address, } = G.wallet.getBracketWallet();

	try {

		//@ts-expect-error - we know this is safe...
		//biome-ignore lint/performance/noDynamicNamespaceImportAccess: to small to be of concern...
		const query = Q[queryName](...args);

		const response = await fetch(GRAPHQL_API, {
			method: "POST",
			body: JSON.stringify({
				query,
			}),
			headers: {
				"Content-Type": "application/json",
				"wallet": address as string,
			},
		});

		if(response.ok) {
			const { data, errors, } = await response.json();
			if(errors) {
				throw new Error(`@bracket/wallet -- GQL query failed ${errors.map((error: Error) => error.message).join(", ")}`);
			}
			if(data) {
				return data;
			}
			throw new Error("wallet::gql:: failed to fetch data");
		}

		throw new Error("graphql query has failed.");
	}
	catch(err) {

		throw new Error(`@bracket/wallet -- GQL query failed ${err instanceof Error ? err.message : "unknown error"}`);

	}

};
